import React from 'react';
import { connect } from 'react-redux';
import { Formik, Field as Fieldmik } from 'formik';
import { Form as FormUi, Segment, Button } from 'semantic-ui-react';
import * as yup from 'yup';

import { DateData } from '../../formikInput/date';

import AddTitleBar from '../../titleBar/addTitleBar';

//Redux Action
import { createTarget } from '../../../redux/actions/targetMasterActions';
import moment from 'moment';



const AddTarget = (props) => {

  const { createTarget } = props;

  //Formik
  const initialValues = {
    target_sales_no: '',
    target_sales_amt: '',
    target_payment_ex: '',
    target_receivable_amt: '',
    monthYear: moment().format('MMMM yyyy')
  }

  const validateSchema = yup.object().shape({
    target_sales_no: yup.number().integer("Target Sales Number is integer only")
      .required('Target Sales Number is Required')
      .typeError('Target Sales Number must specify a number only'),
    target_sales_amt: yup.number().required('Target Sales Amount is Required').typeError('Target Sales Number must specify a number only'),
    target_payment_ex: yup.number().integer("Target Payment is integer only").required('Target Payment is Required').typeError('Target Sales Number must specify a number only'),
    target_receivable_amt: yup.number().required('Target Receivable Amount is Required').typeError('Target Sales Number must specify a number only'),
    monthYear: yup.date().required('Month and Year is Required'),
  })

  const onSubmit = (values, onSubmitProps) => {
    const { target_sales_no, target_sales_amt, target_payment_ex, target_receivable_amt, monthYear } = values
    const customerNumber = localStorage.getItem('customerNo');
    const userId = localStorage.getItem('userId');

    const createTargetData = {
      target_sales_no,
      target_sales_amt,
      target_payment_ex,
      target_receivable_amt,
      month: moment(monthYear).format('MM'),
      year: moment(monthYear).format('YYYY'),
      customer_no: customerNumber,
      user_id: userId
    };
    createTarget(createTargetData).then(() => {
      setTimeout(() => { onSubmitProps.setSubmitting(false) }, 4000)
    });

  };

  return (
    <React.Fragment>
      <AddTitleBar title="New Target" LinkName="/target" />
      <div className="m-2">
        <Formik
          initialValues={initialValues}
          validationSchema={validateSchema}
          onSubmit={onSubmit}
        >
          {({ touched, errors, values, isSubmitting, handleSubmit }) => (
            <>
              <Segment>
                <div className="ui form tiny">
                  <FormUi.Group >
                    <FormUi.Field width="3">
                      <label className="labelName mt-2">Month Year</label>
                    </FormUi.Field>
                    <FormUi.Field width="8">
                      <DateData
                        name={`monthYear`}
                        autoComplete="off"
                        popperClassName="dateTime"
                        dateFormat="MMMM yyyy"
                        showMonthYearPicker
                        placeholderText="Select Month and Year"
                        selected={values.monthYear}
                        selectsStart
                        timeIntervals={5}
                        customInput={<FormUi.Input autoComplete="off" className="dateWidth" icon="time" iconPosition="left" />}
                      /><br />
                      {touched.monthYear && errors.monthYear ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.monthYear}</strong> : ''}
                    </FormUi.Field>
                  </FormUi.Group>
                  <FormUi.Group >
                    <FormUi.Field width="3">
                      <label className="labelName mt-2">Target Sales No</label>
                    </FormUi.Field>
                    <FormUi.Field width="4">
                      <Fieldmik autoComplete="off" type="number" name="target_sales_no" placeholder="Enter Target Sales No" />
                      {touched.target_sales_no && errors.target_sales_no ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.target_sales_no}</strong> : ''}
                    </FormUi.Field>
                    <FormUi.Field width="1" />
                    <FormUi.Field width="3">
                      <label className="labelName mt-2">Target Sales Amount</label>
                    </FormUi.Field>
                    <FormUi.Field width="4">
                      <Fieldmik autoComplete="off" type="number" name="target_sales_amt" placeholder="Enter Target Sales No" />
                      {touched.target_sales_amt && errors.target_sales_amt ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.target_sales_amt}</strong> : ''}
                    </FormUi.Field>
                  </FormUi.Group>
                  <FormUi.Group >
                    <FormUi.Field width="3">
                      <label className="labelName mt-2">Target Payment Ex</label>
                    </FormUi.Field>
                    <FormUi.Field width="4">
                      <Fieldmik autoComplete="off" type="number" name="target_payment_ex" placeholder="Enter Target Payment Ex" />
                      {touched.target_payment_ex && errors.target_payment_ex ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.target_payment_ex}</strong> : ''}
                    </FormUi.Field>
                    <FormUi.Field width="1" />
                    <FormUi.Field width="3">
                      <label className="labelName mt-2">Target Receivable Amount</label>
                    </FormUi.Field>
                    <FormUi.Field width="4">
                      <Fieldmik autoComplete="off" type="number" name="target_receivable_amt" placeholder="Enter Target Receivable Amount" />
                      {touched.target_receivable_amt && errors.target_receivable_amt ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.target_receivable_amt}</strong> : ''}
                    </FormUi.Field>
                  </FormUi.Group>

                </div>
              </Segment>

              <center><Button disabled={isSubmitting} onClick={handleSubmit} size='mini' primary type='submit'>Submit</Button></center>
            </>
          )}
        </Formik>
      </div>
    </React.Fragment>
  )
}


export default connect(null, { createTarget })(AddTarget)


